<template>
  <div id="app">
    <Loading></Loading>

    <!-- 头部 -->
    <NavBar :title="navBar.title" :type="navBar.type" :tips="navBar.tips" :tipsColor="navBar.color">
      <span class="top-back" @click="back" slot="left" :data-track="track"><i class="back-icon" :style="{color: 'rgb(68, 68, 68)'}"></i></span>
      <div class="top-menu" slot="right" v-if="routerName == 'question' || routerName == 'index'" @click="lookProtocol">
        <i class="menu-icon" :style="{color: 'rgb(68, 68, 68)'}"></i>
      </div>
    </NavBar>

    <transition name="fade" mode="out-in" v-if="showMe">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Loading from './components/Loading';
  import NavBar from './components/NavBar';
  import {pageScroll} from './assets/utils';
  import doLogin from './lib/do-login';
  import Cookies from 'js-cookie';

  export default {
    name: 'app',
    data() {
      return {
        showMe: false, // 是否展示当前页面
        routerName: '',
        track: '', // 当前返回埋点
        currentPage: 1,
        size: 20
      };
    },
    components: {NavBar, Loading},
    computed: {
      ...mapState(['navBar', 'backUrl', 'isNoQuestion', 'question', 'price', 'token', 'memberState'])
    },
    mounted() {
      this.loadingtime(600);
      this.getService();
      this.getPriceNew();
      this.getConstantData();
      this.getUserMemberInfo();
    },
    watch: {
      token: {
        handler() {
          this.getService();
          this.getPriceNew();
          this.getUserMemberInfo();
        },
        deep: true
      }
    },
    beforeUpdate() {
      // 更新埋点
      this.routerName = this.$router.currentRoute.name;
      if (this.routerName === 'index') {
        this.track = 'yy_djk_kwys_wdfwfh';
      } else if (this.routerName === 'question') {
        this.track = 'yy_djk_kwys_twfh';
      } else if (this.routerName === 'detail') {
        this.track = 'yy_djk_kwys_xqfh';
      } else if (this.routerName === 'doctor') {
        this.track = 'yy_djk_kwys_ysxqfh';
      }
    },
    methods: {
      // 获取服务列表
      getService() {
        // 第一次 获取问题列表
        this.$store.dispatch('getQuestionList', {
          data: {
            pagesize: this.size,
            curpage: this.currentPage
          },
          isUpdate: false
        }).then((v) => {
          this.showMe = true;
          if (v.err) {
            if (v.err === '无问诊信息') {
              this.$router.push({path: '/question?hideNav=1'});
              this.$store.dispatch('setNoQuestion', true);
              return false;
            } else if (v.err === '用户过期，请重新登录') {
              this.isLogin = false;
            } else {
              this.$dialog.Toast({mes: v.err});
            }
            return false;
          }

          this.$store.dispatch('setNoQuestion', false);
          return true;
        });
      },

      // 获取价格、banner 等信息
      getPriceNew() {
        this.$store.dispatch('getPriceNew').then((v) => {
          this.showMe = true;
          console.log(v);
          // 加入if判断是防止在未登录情况下获取不到data字段报错
          if (v.data) {
            const goodsVipInfo = {
              skuBenefitType: v.data.skuBenefitType,
              otherPrice: parseFloat(v.data.otherPrice)
            };
            this.$store.dispatch('setPrice', parseFloat(v.data.price));
            this.$store.dispatch('setBanner', v.data.banner);
            this.$store.dispatch('setOnlineTime', v.data.onlineTime);
            this.$store.dispatch('setNewMessage', v.data.newMsgCount);
            this.$store.dispatch('setGoodsVipInfo', goodsVipInfo);
          }
        });
      },

      // 返回控制
      back() {
        const webClose = this.$route.query.webClose ? this.$route.query.webClose : 0;
        if (webClose === '1') {
          window.MT.backToNativePage();
        } else {
          const name = this.$route.name;
          if (name === 'question' && window.isApp === 1) {
            // 提问页面返回
            if (this.question.count > 0) {
              if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
                window.Tracking.initTrackUrl(2, 'yy_djk_kwys_fqtw_alert_show', '');
              }
              // 有提示返回
              this.$dialog.Confirm({
                mes: '是否放弃当前编辑的内容？',
                opts: [
                  {
                    txt: '取消',
                    color: false,
                    track: 'yy_djk_kwys_tjxbj',
                    callback: () => {
                      console.log('已经取消返回');
                    }
                  },
                  {
                    txt: '确定',
                    color: true,
                    track: 'yy_djk_kwys_fqtw',
                    callback: () => {
                      if (window.MT) {
                        window.MT.backToNativePage();
                      }
                    }
                  }
                ]
              });
            } else {
              // 无提示返回
              window.MT.backToNativePage();
            }
          } else {
            this.$router.go(-1);
          }
        }
      },

      // 加载loading
      loadingtime(time) {
        this.$store.dispatch('setLoading', true);
        setTimeout(() => {
          this.$store.dispatch('setLoading', false);
        }, time);
      },

      // 查看协议
      lookProtocol() {
        this.$store.dispatch('lookProtocol', true);
        // FIXME: 没有问题的情况，直接去提问页，打开协议滚动不了。
        pageScroll.unlock();
      },

      // 查询会员信息
      getUserMemberInfo() {
        // 微信授权成功后 查询会员信息
        this.$store.dispatch('getUserMemberInfo').then((info) => {
          if (info.rtn_code === '0') {
            const member = info.data;
            const userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
            userInfo.member = member;
            const token = userInfo.token;
            doLogin.info(JSON.stringify(userInfo), token); // 存储授权成功后的信息
          } else {
            this.$dialog.Toast({mes: info.rtn_msg});
          }
        });
      },
      // 获取后台配置的静态数据 根据静态数据获取开通会员文案
      getConstantData() {
        if (!this.constantData) {
          this.$store.dispatch('getConstantData', {
            types: 9,
            version: ''
          }).then((data) => {
            if (data.rtn_code !== '0') {
              this.$dialog.Toast({mes: data.rtn_msg});
            }
          });
        }
      }
    }
  };
</script>

<style lang="less">
  .top-back {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  .top-menu {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// App.vue?4ef3e1a4